import axios from "axios";

interface uploadResourceProps {
  resData: { signedPutRequest: string; url: string };
  fileBuffer: Uint8Array;
  fileType?: { mime: string; ext: string };
}

export const uploadResourceToAWS = async ({ resData, fileBuffer, fileType }: uploadResourceProps) => {
  const { signedPutRequest, url } = resData;

  await axios.put(signedPutRequest, fileBuffer, {
    headers: {
      "Content-Type": fileType ? fileType.mime : "application/octet-stream",
      Accept: "*/*",
    },
  });

  return url;
};
